import * as React from 'react';

import TitleBox from './titleBox';
import { Utils } from '@/utils/app';

import './index.less';

const { handleClickLiveRep, jumpGameDetail} = Utils;

function LiveGame(props: any) {
  const { liveData = [], gameBaseInfo = {}, fromId, handTipsImgVis} = props;

  const getRep = (obj: any) => {
    const newObj = {
      gamename: gameBaseInfo?.gameName,
      gameid: gameBaseInfo?.gameId,
      area: obj?.area,
      anchor_uid: obj?.anchorUid,
      game_id: obj?.gid,
      position: obj?.index,
    };
    handleClickLiveRep(newObj);
  };

  const handleJumpLive = (item: any) => {
    getRep({ area: 'card', gid: item.gid, anchorUid: item.anchorUid });
    // window.location.href = item.liveJumpUrl;
    jumpGameDetail({gameId: gameBaseInfo?.gameId, fromId}, handTipsImgVis);
  };
  const getPopText = (value: any = 0) => {
    const val = Number(value);
    if (!val) return null;
    if (val > 10000) {
      return `${(val / 10000).toFixed(1)}万`;
    } else {
      return val;
    }
  };

  const liveTitleBoxProps = {
    title: '相关直播',
    more: '查看全部',
    jumpMore: () => {
      // 跳转全部直播间
      getRep({ area: 'all' });
      jumpGameDetail({gameId: gameBaseInfo?.gameId, fromId}, handTipsImgVis);
    },
  };

  return (
    <>
      {!!(liveData || []).length ? <TitleBox {...liveTitleBoxProps} /> : null}
      <div className='live-game-c'>
        {(liveData || []).map((item: any, i: number) => (
          <div className='l-g-c-box' key={`${item.anchorUid}_${i}`} onClick={() => handleJumpLive({ ...item, index: i + 1 })}>
            <div className='g-c-b-top'>
              <div className='mask'></div>
              <img src={item.cover} alt='' />
              {item.anchorTag[0] ? <div className='c-b-t-tag'>{item.anchorTag[0]}</div> : null}
              <div className='c-b-t-info'>
                <span className='t-i-user'>{item.nick}</span>
                <span className='t-i-num'>
                  <img src={item.avatar} alt='' />
                  {getPopText(item.popularityValue)}
                </span>
              </div>
            </div>
            <div className='g-c-b-bottom'>{item.liveRoomDesc}</div>
          </div>
        ))}
      </div>
    </>
  );
}

export default LiveGame;
